var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAskHelp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.31453 1.53349C9.11687 1.43265 8.88287 1.43265 8.68529 1.53349L2.06724 4.91004L1.43797 3.67667L8.05598 0.30012C8.64894 -0.00238377 9.35087 -0.00238377 9.94384 0.30012L16.5618 3.67667C17.1229 3.96295 17.3706 4.53504 17.3076 5.07457V9.07652C17.3076 9.45888 16.9976 9.76883 16.6153 9.76883C16.233 9.76883 15.923 9.45888 15.923 9.07652V6.45655L14.5153 7.14602V9.98012C14.5153 10.7443 14.0957 11.4468 13.4228 11.8089L9.98433 13.6598C9.3697 13.9906 8.63004 13.9906 8.01548 13.6598L4.57703 11.8089C3.90415 11.4468 3.48452 10.7443 3.48452 9.98012V7.14602L1.45819 6.15353C0.433468 5.6516 0.421586 4.19524 1.43797 3.67667L2.06724 4.91004L8.6954 8.15644C8.88751 8.2506 9.1123 8.2506 9.30442 8.15644L15.923 4.91471C15.9231 4.91155 15.9231 4.9084 15.9232 4.90525L9.31453 1.53349ZM4.86914 7.8242V9.98012C4.86914 10.2349 5.00901 10.469 5.2333 10.5898L8.67179 12.4406C8.87664 12.5509 9.12317 12.5509 9.32803 12.4406L12.7665 10.5898C12.9908 10.469 13.1307 10.2349 13.1307 9.98012V7.8242L9.91344 9.39997C9.33717 9.68222 8.66265 9.68222 8.0863 9.39997L4.86914 7.8242Z",
    fill: "#76D0EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskHelp);
export default __webpack_public_path__ + "static/media/askHelp.0c0d35656ce9e84cf6e57d9e45372d3d.svg";
export { ForwardRef as ReactComponent };